<template>
  <v-main>
    <v-container fill-height fluid>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <ValidationObserver ref="form" v-slot="{ passes }">
              <v-card-title>
                <h3>{{$t('language.login')}}</h3>
              </v-card-title>
              <v-card-text>
                <v-form>
                  <ValidationProvider name="username" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model="username"
                      :label="$t('language.username')"
                      :error-messages="errors[0]"
                      prepend-icon="mdi-account"
                    />
                  </ValidationProvider>
                  <ValidationProvider name="password" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model="password"
                      :label="$t('language.password')"
                      :error-messages="errors[0]"
                      :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                      :type="showPassword ? 'text' : 'password'"
                      prepend-icon="mdi-lock"
                      @keydown.enter="passes(submit)"
                      @click:append="showPassword = !showPassword"
                    />
                  </ValidationProvider>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  align-center
                  justify-center
                  color="general"
                  @click="passes(submit)"
                >{{$t('language.login')}}</v-btn>
                <v-spacer />
                <router-link to="/account/forgotpassword" class="tertiary--text">{{$t('language.forgotpassword')}}</router-link>
              </v-card-actions>
            </ValidationObserver>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data: function() {
    return {
      username: "",
      password: "",
      showPassword: false
    };
  },
  methods: {
    submit: function() {
      let username = this.username;
      let password = this.password;
      this.$store
        .dispatch("login", { username, password })
        .then(() => this.$router.push("/dashboard"));
    }
  },
  metaInfo() {
    return {
      title: this.$store.getters.applicationtitle + " | Login"
    };
  }
};
</script>
